import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { BatchCrudService } from 'src/app/shared/services/batch-crud.service';
import { Batch } from 'src/app/shared/interfaces/batch';
import { WineCrudService } from 'src/app/shared/services/wine-crud.service';
import { Wine } from 'src/app/shared/interfaces/wine';

@Component({
  selector: 'app-batches',
  templateUrl: './batches.component.html',
  styleUrls: ['./batches.component.scss']
})
export class BatchesComponent implements OnInit {

  batches: Batch[];
  batch: Batch;
  selectedBatches: Batch[] = [];

  wines: Partial<Wine>[];
  winesMap : Map<string,Wine>;
  years: number[];

  batchDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private batchService : BatchCrudService,
    private wineService : WineCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Batches'}
    ];

    this.batches = [];
    this.batch = { } as Batch ;

    this.wines = [];
    this.winesMap = new Map<string,Wine>();
  
    this.years = [];
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.batchService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.batches = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Batch = jsonItem as Batch;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.batches.push(l);
        }
      })
    });

    let w = this.wineService.getList(); 
    w.snapshotChanges().subscribe(data => {
      this.wines = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Wine = jsonItem as Wine;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          let ll : Partial<Wine> = l;
          delete ll.$key;
          this.wines.push(ll);
          this.winesMap.set( l.$key , l);
        }
      })
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'wine', header: 'Wine' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.batchService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.batches);
            doc.save('batches.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.batches);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "batches");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedBatches);
      // console.log('SAVEC CSV LOCATIONS ', this.batches);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedBatches, 'batches', exportCols);
   // this.exportService.exportToCsv(this.batches, 'batches', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.batch = {} as Batch;
    this.submitted = false;
    this.batchDialog = true;
  }

  deleteSelectedBatches() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected batches?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.batches = this.batches.filter(val => !this.selectedBatches.includes(val));
            
            this.selectedBatches.forEach( batch => this.batchService.delete(batch.$key));
            this.selectedBatches = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Batchess Deleted', life: 3000});
        }
    });
  }

  editBatch(batch: Batch) {
    this.batch = {...batch};
    this.batchDialog = true;
  }

  deleteBatch(batch: Batch) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + batch.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.batches = this.batches.filter(val => val.$key !== batch.$key);
            this.batch = {} as Batch;
            this.batchService.delete(batch.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Batch Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.batchDialog = false;
    this.submitted = false;
  }

  saveBatch() {
    this.submitted = true;

    if ( this.batch.name.trim() ) {
      this.batch.isEnabled = true;
      
      if (this.batch.$key) {
          this.batches[this.findIndexById(this.batch.$key)] = this.batch;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Batch Updated', life: 3000});
          this.batchService.update(this.batch);
        } else {
          this.batch.position = this.batches.length;
          this.batchService.add(this.batch);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Batch Created', life: 3000});
      this.batches = [...this.batches];
    }

    this.batchDialog = false;
    this.batch = { } as Batch;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.batches.length; i++) {
        if (this.batches[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeBatch(batch : Batch) {
    //console.log("SAVE", batch);
    if (batch.wine) {
      delete batch.wine.$key;
    }
    this.batchService.update(batch);
  }

  completePosition(batch : Batch) {
   // console.log("SAVE", batch);
  //  this.batchService.updateBatch(batch);


    if ( this.newPosition > -1 ) {
        batch.position = this.newPosition;
        batch = this.checkPositionLimits(batch);
        this.reorderElements(batch);
        //this.updateDB(batch);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.batches);
    // const myClonedArray = [];
    // this.batches.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.batches.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.batches.length - 1 - event.dropIndex;
    const batchToMove = this.batches[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.batches[index] = this.batches[index+1];
        this.batches[index].position = index;
        this.batchService.update(this.batches[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.batches[index] = this.batches[index-1];
        this.batches[index].position = index;
        this.batchService.update(this.batches[index]);
      }
    } 
    this.batches[endIndex] = batchToMove;
    this.batches[endIndex].position = endIndex;
    this.batchService.update(this.batches[endIndex]);
  }

  // onFieldEdit(batch: Spray, fieldName: string): void {
  //   //console.log(this.batches);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + batch[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       batch.position = this.newPosition;
  //       batch = this.checkPositionLimits(batch);
  //       this.reorderElements(batch);
  //       //this.updateDB(batch);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(batch);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.batches.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, batch: Batch) {
    // console.log("event" +event);
    if (batch.position != null && batch.position > -1) {
      this.previousPosition = batch.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(batch: Batch) {
    console.log('check ',batch.position + ' ' + this.batches.length);
    if (!batch.position) {
     // console.log('check 1');
      return this.batch;
    }
    if (batch.position < 0) {
      batch.position = 0;
      // console.log('check 2');
      return batch;
    }
    if (batch.position > this.batches.length) {
      batch.position = this.batches.length - 1;
    //  console.log('check 3', batch.position);
      return batch;
    }
   // console.log('check 4');
    return batch;
  }

  async reorderElements(batch: Batch) {
    this.newPosition = this.newPosition  > this.batches.length ? this.batches.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === batch.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const batchToMove = this.batches[startIndex];
   // console.log('Item to move: ', this.batches[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.batches);
        console.log('Item to +1: ', this.batches[index+1]);

        this.batches[index] = this.batches[index+1];
        this.batches[index].position = index;
        // console.log('Move: ', this.batches[index+1]);
        // console.log('Move pos: ', this.batches[index].position);
        //await this.updateDB(this.batches[index]);
        this.batchService.update(this.batches[index]);
     //   console.log('Update DB: ', this.batches[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.batches[index] = this.batches[index-1];
        this.batches[index].position = index;
        this.batchService.update(this.batches[index]);
      }
    } 
    this.batches[endIndex] = batchToMove;
    this.batches[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.batchService.update(this.batches[endIndex]);
    
    // const myClonedArray = [];
    // this.batches.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.batches = myClonedArray;
   // this.getAllRecords();
  }
}
